const optionalText = (value) => {
  if (value === undefined || value === null) return null;
  const text = String(value).trim();
  return text || null;
};

const normaliseEnquiry = (payload) => ({
  type: payload.type === "booking" ? "booking" : "contact",
  name: optionalText(payload.name),
  email: optionalText(payload.email),
  phone: optionalText(payload.phone),
  child_age: optionalText(payload.child_age),
  service: optionalText(payload.service),
  preferred_setting: optionalText(payload.preferred_setting),
  region: optionalText(payload.region),
  message: optionalText(payload.message),
});

const normaliseReview = (payload) => ({
  name: optionalText(payload.name),
  suburb: optionalText(payload.suburb),
  text: optionalText(payload.text),
});

const notifySiteOwner = async (kind, payload) => {
  try {
    await fetch("/api/notify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ kind, payload }),
    });
  } catch {
    // Email notifications should not block the visitor-facing form success state.
  }
};

const submitEnquiryEndpoint = async (row) => {
  const response = await fetch("/api/enquiries", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ payload: row }),
  });
  const contentType = response.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    throw new Error("Enquiry endpoint is unavailable");
  }

  const body = await response.json();

  if (!response.ok || !body?.ok) {
    const error = new Error(body?.error || "Could not submit enquiry");
    error.status = response.status;
    error.endpointResponse = true;
    error.delivery = body?.delivery;
    throw error;
  }

  return body;
};

export const submitEnquiry = async (payload) => {
  const row = normaliseEnquiry(payload);
  return submitEnquiryEndpoint(row);
};

export const submitReview = async (payload) => {
  const row = normaliseReview(payload);
  const response = await fetch("/api/reviews", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ payload: row }),
  });
  const contentType = response.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    throw new Error("Review endpoint is unavailable");
  }

  const body = await response.json();
  if (!response.ok || !body?.ok) {
    throw new Error(body?.error || "Could not submit review");
  }

  notifySiteOwner("review", row);
  return body.review || row;
};

export const fetchReviews = async () => {
  const response = await fetch("/api/reviews", {
    headers: { Accept: "application/json" },
  });
  const contentType = response.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    throw new Error("Review endpoint is unavailable");
  }

  const body = await response.json();
  if (!response.ok || !body?.ok || !Array.isArray(body.reviews)) {
    throw new Error(body?.error || "Could not load reviews");
  }

  return body.reviews;
};
